import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function TruckHomologationCheckbox() {
  return (
    <Field
      type="checkbox"
      name="truckHomologation"
      label={i18n.t('entity.vehicle.labels.truckHomologation')}
    />
  );
}
